export function getNestedValueFromKeyDotPath(obj: object, path: string) {
  const keys = path.split('.');

  let result: object | string | number | undefined = obj;
  for (const k of keys) {
    if (typeof result === 'string' || typeof result === 'number') {
      return String(result);
    }
    if (!result) {
      return String(result);
    }

    result = result[k as keyof typeof result];
  }

  return String(result);
}
